import React, {useEffect, useState} from 'react';

import styles from './DeliveryPickup.module.css'
import {Button} from "../../../../../../ui/General/Button/Button.tsx";
import {Order} from "../../../../../../types/Order.interface.ts";
import {Map, Placemark, YMaps} from "@pbe/react-yandex-maps";
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';
// import { useMultiStorage } from '../../../../../../hooks/useStorage.ts';

interface Props {
    setIsBranchShown: (isBranchShown: boolean) => void
}

export const DeliveryPickup: React.FC<Props> = ({setIsBranchShown}) => {
    const [isMapShown, setIsMapShown] = useState(false);
    const [offer, setOffer] = useState<Order|null>(null);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    const [centerMapCoordinates, setCenterMapCoordinates] = useState<[number, number]>([43.136782, 131.930598]);
    // const storage = useMultiStorage({
    //     cartOffer: ['cartOffer', offer],
    //   })[0];

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            if(cartOffer.delivery.point.latitude && cartOffer.delivery.point.longitude) {
                setCenterMapCoordinates([cartOffer.delivery.point.latitude, cartOffer.delivery.point.longitude]);
            }
        }
    }, [cartOffer]);

    if(!offer) return null;

    return (
        <>
            <h3 className={styles.title}>Выбранный пункт самовывоза:</h3>
            <div className={styles.point}>
                {offer.delivery.point.address}
            </div>
            <div className={styles.schedule}>
                {offer.delivery.point.schedule.split(',').map((hours) => {
                    return <div key={hours}>{hours}</div>
                })}
            </div>
            <div className={styles.buttons}>
                <Button type='regular' className={styles.btnChoosePoint} onClick={() => setIsBranchShown(true)}>
                    Выбрать другой
                </Button >
                <Button className={styles.btnOpenMap} type='text' onClick={() => setIsMapShown(!isMapShown)}>
                    Открыть карту
                </Button>
            </div>
            {
                isMapShown && offer.accessibilityBranches.length ?
                    (<YMaps>
                        <Map
                            defaultState={{
                                zoom: 14,
                                controls: [],
                                center: centerMapCoordinates,
                            }}
                            width="100%"
                            height={485}
                        >
                            {offer.accessibilityBranches.map(branch => {
                                if(!branch.latitude || !branch.longitude) return null;

                                return  <Placemark
                                    modules={["geoObject.addon.balloon"]}
                                    key={branch.id}
                                    defaultGeometry={[branch.latitude, branch.longitude]}
                                    properties={{
                                        balloonContentBody:`<div>Адрес: ${branch.address}</div>`
                                    }}
                                />
                            })}
                        </Map>
                    </YMaps>)
                    : null}
        </>
    );
};